import { render, staticRenderFns } from "./exception-reasons.vue?vue&type=template&id=6b2d3f18"
import script from "./exception-reasons.vue?vue&type=script&lang=js"
export * from "./exception-reasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports